import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import EventClipsContainer from '../../smart/menuComponentsContainer/EventClipsContainer';
import EventFlagged from '../../smart/menuComponentsContainer/EventFlagged';
import EventClipsQuarantine from '../../smart/menuComponentsContainer/EventClipsQuarantine';
import GreyHeader from '../../GreyHeader'
import CustomButton from '../../CustomButton';

const Events = (props) => {
	const location = useLocation();
	const { roles, permissions } = props.user;
	const userRole = roles[0];
	const { t } = useTranslation();
	const [tabKey, setTabKey] = useState(1);
	const [locationData, setLocationData] = useState(null);
	const [selectedEvent, setSelectedEvent] = useState();
	const [eventPageData, setEventPageData] = useState(() => (
		location.state?.type === 'redirectFromDashboardEventBreakdown'
			? { start_date: location.state.start_date, end_date: location.state.end_date }
			: null
	));

	useEffect(() => {
		if (location?.state && location.state.type !== 'redirectFromDashboardEventBreakdown') {
			setLocationData(location);
		} else {
			setLocationData(false);
		}
	}, [location]);

	const handleSelect = (tabKey, selectedEvent = null) => {
		selectedEvent && setSelectedEvent(selectedEvent);
		setTabKey(tabKey);
	};

	const hasEditPermission = !(['custom_user', 'custom_partner'].includes(userRole) && _.find(permissions, { 'perm_category_id': 2, 'a_edit': false }))

	return (
		<div className="events-page">
			<GreyHeader
				title={t('eventsPage.events.titleEvents')}
				renderSubtitle={
					hasEditPermission &&
					(<nav className='page-subtitle'>
						<CustomButton variant='subtitle' active={tabKey === 1} onClick={() => handleSelect(1)}>
							{t('eventsPage.events.btnDailyEvents')}
						</CustomButton>
						<CustomButton variant='subtitle' active={tabKey === 2} onClick={() => handleSelect(2)}>
							{t('eventsPage.events.btnFlaggedEvents')}
						</CustomButton>
						<CustomButton variant='subtitle' active={tabKey === 3} onClick={() => handleSelect(3)}>
							{t('eventsPage.events.btnQuarantine')}
						</CustomButton>
					</nav>)
				}
			/>

			{tabKey === 1 &&
				<EventClipsContainer
					location={locationData}
					handleSelect={handleSelect}
					eventPageData={eventPageData}
					setEventPageData={setEventPageData}
				/>}
			{tabKey === 2 &&
				<EventFlagged
					eventPageData={eventPageData}
					setEventPageData={setEventPageData}
				/>}
			{tabKey === 3 &&
				<EventClipsQuarantine
					selectedEvent={selectedEvent}
					eventPageData={eventPageData}
					setEventPageData={setEventPageData}
				/>}
		</div>
	)
}

Events.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ user }) => ({
	user: user.user
});

export default connect(mapStateToProps)(Events);
